import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
import { DxGridRow } from "../../dx-grid/domain/dx-grid-row";
import { PitActivity } from "./pit-activity";
/** Строка грида с мероприятиями. */
let PitActivityGridRow = class PitActivityGridRow extends DxGridRow {
    constructor() {
        super();
        /** Общие реквизиты мероприятия */
        this._activity = new PitActivity();
        this._isNew = !this._id;
    }
    /** вкючалка кнопок на тулбаре */
    canExecuteToolbarAction(action) {
        switch (action.type) {
            case 'COPY':
                return this.statusId == 3 || this.statusId === 4;
        }
        return true;
    }
    getRowId() {
        return this._id ? this._id : this._rowId;
    }
    getRowTitle() {
        return 'мероприятие ' + this._code;
    }
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    get code() {
        return this._code;
    }
    set code(value) {
        this._code = value;
    }
    get activityCode() {
        return this._activity.code;
    }
    set activityCode(value) {
        this._activity.code = value;
    }
    get name() {
        return this._activity.name;
    }
    set name(value) {
        this._activity.name = value;
    }
    get type() {
        return this._activity.typeId;
    }
    set type(value) {
        this._activity.typeId = value;
    }
    get totalAmount() {
        return this._totalAmount;
    }
    set totalAmount(value) {
        this._totalAmount = value;
    }
    get firstPeriodAmount() {
        return this._firstPeriodAmount;
    }
    set firstPeriodAmount(value) {
        this._firstPeriodAmount = value;
    }
    get secondPeriodAmount() {
        return this._secondPeriodAmount;
    }
    set secondPeriodAmount(value) {
        this._secondPeriodAmount = value;
    }
    get thirdPeriodAmount() {
        return this._thirdPeriodAmount;
    }
    set thirdPeriodAmount(value) {
        this._thirdPeriodAmount = value;
    }
    get stateProgramId() {
        return this._stateProgramId;
    }
    set stateProgramId(value) {
        this._stateProgramId = value;
    }
    get funcCustomerId() {
        return this._funcCustomerId;
    }
    set funcCustomerId(value) {
        this._funcCustomerId = value;
    }
    get govCustomerId() {
        return this._govCustomerId;
    }
    set govCustomerId(value) {
        this._govCustomerId = value;
    }
    get activityId() {
        return this._activity.id;
    }
    get curatorId() {
        return this._activity.curatorId;
    }
    get activity() {
        return this._activity;
    }
    set activity(value) {
        this._activity = value;
    }
    get blockId() {
        return this._blockId;
    }
    set blockId(value) {
        this._blockId = value;
    }
    get subBlockId() {
        return this._subBlockId;
    }
    set subBlockId(value) {
        this._subBlockId = value;
    }
    get statusId() {
        return this._statusId;
    }
    set statusId(value) {
        this._statusId = value;
    }
    get purchaseStartPlanDate() {
        return this._purchaseStartPlanDate;
    }
    set purchaseStartPlanDate(value) {
        this._purchaseStartPlanDate = value;
    }
    get actualDate() {
        return this._actualDate;
    }
    set actualDate(value) {
        this._actualDate = value;
    }
    get changeDate() {
        return this._changeDate;
    }
    set changeDate(value) {
        this._changeDate = value;
    }
    get changeUserFio() {
        return this._changeUserFio;
    }
    set changeUserFio(value) {
        this._changeUserFio = value;
    }
    get planTypeId() {
        return this._planTypeId;
    }
    set planTypeId(value) {
        this._planTypeId = value;
    }
    get isFinishedStr() {
        return (this._activity.isFinished) ? 'Да' : 'Нет';
    }
};
tslib_1.__decorate([
    jsonMember({ name: "id", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityGridRow.prototype, "_id", void 0);
tslib_1.__decorate([
    jsonMember({ name: "code", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitActivityGridRow.prototype, "_code", void 0);
tslib_1.__decorate([
    jsonMember({ name: "activity", constructor: PitActivity, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", PitActivity)
], PitActivityGridRow.prototype, "_activity", void 0);
tslib_1.__decorate([
    jsonMember({ name: "name", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitActivityGridRow.prototype, "_name", void 0);
tslib_1.__decorate([
    jsonMember({ name: "type", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityGridRow.prototype, "_type", void 0);
tslib_1.__decorate([
    jsonMember({ name: "totalAmount", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityGridRow.prototype, "_totalAmount", void 0);
tslib_1.__decorate([
    jsonMember({ name: "firstPeriodAmount", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityGridRow.prototype, "_firstPeriodAmount", void 0);
tslib_1.__decorate([
    jsonMember({ name: "secondPeriodAmount", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityGridRow.prototype, "_secondPeriodAmount", void 0);
tslib_1.__decorate([
    jsonMember({ name: "thirdPeriodAmount", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityGridRow.prototype, "_thirdPeriodAmount", void 0);
tslib_1.__decorate([
    jsonMember({ name: "stateProgramId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityGridRow.prototype, "_stateProgramId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "funcCustomerId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityGridRow.prototype, "_funcCustomerId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "govCustomerId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityGridRow.prototype, "_govCustomerId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "blockId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityGridRow.prototype, "_blockId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "subBlockId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityGridRow.prototype, "_subBlockId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "statusId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityGridRow.prototype, "_statusId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "purchaseStartPlanDate", constructor: Date, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Date)
], PitActivityGridRow.prototype, "_purchaseStartPlanDate", void 0);
tslib_1.__decorate([
    jsonMember({ name: "actualDate", constructor: Date, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Date)
], PitActivityGridRow.prototype, "_actualDate", void 0);
tslib_1.__decorate([
    jsonMember({ name: "changeDate", constructor: Date, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Date)
], PitActivityGridRow.prototype, "_changeDate", void 0);
tslib_1.__decorate([
    jsonMember({ name: "changeUserFio", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitActivityGridRow.prototype, "_changeUserFio", void 0);
tslib_1.__decorate([
    jsonMember({ name: "planTypeId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityGridRow.prototype, "_planTypeId", void 0);
PitActivityGridRow = tslib_1.__decorate([
    jsonObject,
    tslib_1.__metadata("design:paramtypes", [])
], PitActivityGridRow);
export { PitActivityGridRow };
